import { chartPaletteSelection } from '@/features/dashboard/components/AppForm/AppForm/components/ColorPaletteSelector/const';
import { useAppForm } from '@/features/dashboard/components/AppForm/AppForm/context';
import { SymbolAlias } from '@/features/dashboard/components/SymbolAlias/';

const ColorSelectionList = () => {
  const { form } = useAppForm();

  return (
    <form.Subscribe
      selector={s => ({
        symbols: s.values?.symbols,
        colorPalette: s.values && 'colorPalette' in s.values ? s.values.colorPalette : undefined,
        type: s.values?.type
      })}
    >
      {({ symbols, colorPalette, type }) => {
        const palette = chartPaletteSelection.find(item => item.id === colorPalette);
        if (!palette) return null;

        const symbolsToPreview = symbols?.active.slice(0, palette.palette.length) ?? [];

        return (
          <div className='mb-2 flex flex-col'>
            <div className='grid grid-cols-[100px_100px_minmax(0,1fr)] px-3 pb-2 text-sm font-medium'>
              <span>Color</span>
              <span>Alias</span>
              <span>Short Title</span>
            </div>
            <div className='flex flex-col gap-2'>
              {symbolsToPreview.map((symbol, index) => (
                <div
                  key={JSON.stringify(symbol.symbol)}
                  className='grid grid-cols-[100px_100px_minmax(0,1fr)] items-center rounded-lg border border-border p-3 text-sm'
                >
                  <span className='flex items-center gap-2'>
                    <span
                      aria-hidden='true'
                      className='size-4'
                      style={{ backgroundColor: palette.palette[index].hex }}
                    />
                    {palette.palette[index].name}
                  </span>
                  <SymbolAlias
                    symbol={symbol}
                    type={type}
                  />
                  <span className='min-w-0 max-w-[300px] truncate'>{symbol.shortTitle}</span>
                </div>
              ))}
            </div>
          </div>
        );
      }}
    </form.Subscribe>
  );
};

export default ColorSelectionList;
